import { reactive } from "vue";

export function createStopwatch() {
    let intervalId = null;
    let startedAt = null;

    const stopwatch = reactive({
        elapsedMs: 0,

        start() {
            if (intervalId !== null) {
                return;
            }

            startedAt = Date.now() - this.elapsedMs;

            intervalId = setInterval(() => {
                this.elapsedMs = Date.now() - startedAt;
            }, 200);
        },

        pause() {
            if (intervalId === null) {
                return;
            }

            clearInterval(intervalId);
            intervalId = null;
            this.elapsedMs = Date.now() - startedAt;
            startedAt = null;
        },

        reset() {
            this.elapsedMs = 0;

            if (intervalId !== null) {
                startedAt = Date.now();
            }
        },

        get totalSeconds() {
            return Math.floor(this.elapsedMs / 1000);
        },

        get hours() {
            return Math.floor(this.totalSeconds / 3600);
        },

        get minutes() {
            return Math.floor((this.totalSeconds % 3600) / 60);
        },

        get seconds() {
            return this.totalSeconds % 60;
        },

        get isRunning() {
            return intervalId !== null;
        }
    });

    return stopwatch;
}